import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import type { CustomValidationConfiguration } from './custom-validation.directive';

export const PalantirRegExpValidation = {
  validate: (control: AbstractControl<any, any>): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    try {
      const value = control.value;
      // eslint-disable-next-line sonarjs/no-ignored-return
      new RegExp(value).test('');
      return null;
    } catch (error: unknown) {
      return {
        regexp: true,
        message: (error as Error).message.replace(/^.*:\s/, ''),
      };
    }
  },
};

export function createCustomValidation(configuration: CustomValidationConfiguration): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!configuration?.validationRegexp) {
      return null;
    }

    const value = control.value;
    const regexp = new RegExp(configuration.validationRegexp);

    if (regexp.test(value)) {
      return null;
    }

    return {
      customValidation: true,
      customValidationMessage: configuration.validationMessage ?? 'Invalid input',
    };
  };
}
